module.exports = __webpack_public_path__ + "static/media/writing.11180bb9.png";